  /**
   * @ngdoc directive
   * @name closing.directive:closing
   * @restrict EA
   * @element
   *
   * @description
   *
   * @example
   <example module="closing">
   <file name="index.html">
   <closing></closing>
   </file>
   </example>
   *
   */

  (function () {
    'use strict';
    angular.module('vcfinance.closing')
      .component('closing', {
        restrict: 'E',
        templateUrl: 'vcfinance/closing/closing-component.tpl.html',
        controllerAs: 'vm',
        controller: ['Closing', '$log', '$http',
          function (Closing, $log, $http) {
            let vm = this;
            vm.startdate = new Date(moment().year(), 0, 1).toISOString();
            // vm.enddate = new Date().toISOString();
            vm.enddate = moment().add(1, 'days').toISOString();
            vm.rangequery = rangequery;
            vm.lastmonth = lastmonth;
            vm.freeinterval = freeinterval;

            function lastmonth() {
              let lastm = moment().subtract(1, 'month');
              let start = lastm.startOf('month').toISOString();
              let end = lastm.endOf('month').toISOString();
              $log.debug('Startdate: ', start);
              $log.debug('enddate: ', end);
              let cashname = 'umsatz_bar_karte-' + lastm.format('YYYY_MM') + '.csv';
              let checkname = 'umsatz_zielrechnung-' + lastm.format('YYYY_MM') + '.csv';
              rangequery(start, end, '/routes/fiscaljournal', cashname);
              rangequery(start, end, '/routes/checkjournal', checkname);
            }

            function freeinterval() {
              let start = moment.utc(vm.startdate).toISOString();
              let end = moment.utc(vm.enddate).toISOString();
              $log.debug('Startdate: ', start);
              $log.debug('enddate: ', end);
              let cashname = 'umsatz_bar_karte.csv';
              let checkname = 'umsatz_zielrechnung.csv';
              rangequery(start, end, '/routes/fiscaljournal', cashname);
              rangequery(start, end, '/routes/checkjournal', checkname);
              vm.start = null;
              vm.end = null;
            }

            function rangequery(start, end, url, filename) {
              let query = {
                created: {
                  $gte: start,
                  $lt: end
                }
              };
              let qq = {
                $gte: start,
                $lt: end
              };

              $log.debug('query: ', JSON.stringify(qq));
              let tmp = url + '?created=' + encodeURIComponent(JSON.stringify(qq));
              $log.debug('tmp: ', tmp);
              // $log.debug('query: ', JSON.stringify(query));
              $http.get(tmp, {})
                .success(function (data, status, headers, config) {
                  let anchor = angular.element('<a/>');
                  anchor.attr({
                    href: 'data:attachment/csv;charset=utf-8,' + encodeURI(data),
                    target: '_blank',
                    download: filename
                  })[0].click();
                })
                .error(function (data, status, headers, config) {
                  $log.error('Ficaljournal filegeneration and export failed');
                  $log.error(status);
                  $log.error(headers);
                  $log.error(data);
                });
            }


          }] // controller
      }); // component

// klammerfriedhof
  }());
